import { render, staticRenderFns } from "./CurrentUnclosedInvoicesDialog.vue?vue&type=template&id=0d07523d&scoped=true"
import script from "./CurrentUnclosedInvoicesDialog.vue?vue&type=script&lang=js"
export * from "./CurrentUnclosedInvoicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07523d",
  null
  
)

export default component.exports